import type { ReactNode } from 'react'
import type { ValueOf } from '@shared/lib'

export const ToastVariant = {
  success: 'success',
  error: 'error',
  info: 'info',
  loading: 'loading',
} as const
export type ToastVariant = ValueOf<typeof ToastVariant>
export interface ToastItem {
  id: string
  title: string
  description?: ReactNode
  variant?: ToastVariant
  // Auto-dismiss delay in ms. Pass `Infinity` (or omit on a `loading` toast) to
  // keep the toast open until it is updated or dismissed programmatically.
  duration?: number
  // When false, hides the close button and ignores swipe/escape dismissal —
  // used for in-progress toasts that must stay until the work finishes.
  dismissible?: boolean
}
